// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parents-info-title[data-v-13f47d54] {\n  color: var(--main-dark-color);\n}\n.btn[data-v-13f47d54] {\n  background-color: var(--main-dark-color);\n  border-color: var(--main-dark-color);\n  border-radius: 10px;\n}\n.title-hr[data-v-13f47d54] {\n  border-top: 1px solid var(--main-dark-color);\n}\n.parent-info-card[data-v-13f47d54] {\n  color: var(--text-light-color);\n}", ""]);
// Exports
module.exports = exports;
